import { GET_TICKET_TRIAGE } from '@nile/banyan/src/Graphql/Query/ai';
import {
  BETA_AI_FEATURES,
  EventEmitter,
  getTranslatedText
} from '@nile/components';
import AIKnowledgeBase from '@nile/components/src/Components/AI/components/AIArticleSolutions/AIKnowledgeBase';
import AIRecommendedSolutions from '@nile/components/src/Components/AI/components/AIRecommendedSoutions/index.js';
import AISimilarTickets from '@nile/components/src/Components/AI/components/AISimilarTickets';
import AITicketTriage from '@nile/components/src/Components/AI/components/AITicketTriage/AITicketTriage.tsx';
import EmojiRender from '@nile/components/src/Components/EmojiRender';
import AIFeaturesHook from '@nile/components/src/Utils/aiFeaturesHook';
import {
  GET_AI_RECOMMENDED_SOLUTIONS_V2,
  GET_AI_SIMILAR_TICKETS,
  GET_CATEGORY_SUMMARY,
  GET_TICKET_WORKLOG_SUMMARY,
  TicketClient
} from '@nile/graphql/src';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import { GET_AI_KB_ARTICLE_V2 } from '@nile/rmm/src/modules/knowledge-base/graphql';
import { GET_AI_README } from '@nile/rmm/src/modules/scripts/Graphql';
import { SVGIcon } from '@superops/super-icons';
import React, { useContext } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import TicketCategorySummary from './components/TicketCategorySummary';
import TicketWorklogSummary from './components/TicketWorklogSummary';
import { AI_AGENTS_MAP, AI_IN_TICKET_DETAILS } from './helpers/constants';
import { AIOnboardingHook } from './hooks/AIOnboardingHook.tsx';

// AIPHASE_2_TODO: CHANGE API, Header and Loader Text

const AI_CONFIG = {
  TICKET: {
    options: AI_IN_TICKET_DETAILS
  },
  ONBOARD: {
    url: [
      {
        url: 'reply',
        options: [],
        onboardMessage: [
          <FormattedMessage
            id="msp.ai.settings.reply.template.onboard.message.1"
            values={{
              b: (txt) => <b>{txt}</b>,
              img: <SVGIcon name="AIWand" size="sm" />
            }}
          />,
          <FormattedMessage
            id="msp.ai.settings.reply.template.onboard.message.2"
            values={{
              b: (txt) => <b>{txt}</b>,
              img: <SVGIcon name="AIWand" size="sm" />
            }}
          />,
          <FormattedMessage
            id="msp.ai.settings.reply.template.onboard.message.3"
            values={{
              b: (txt) => <b>{txt}</b>,
              img: <SVGIcon name="AIWand" size="sm" />
            }}
          />,
          <FormattedMessage
            id="msp.ai.settings.reply.template.onboard.message.4"
            values={{
              b: (txt) => <b>{txt}</b>,
              img: <SVGIcon name="AIWand" size="sm" />
            }}
          />
        ]
      },
      {
        url: 'aifeatures',
        options: [],
        onboardMessage: [
          <FormattedMessage
            id="msp.ai.settings.ai.page.onboard.message.1"
            values={{
              emoji: <EmojiRender emoji="😉" />
            }}
          />,
          <FormattedMessage
            id="msp.ai.settings.ai.page.onboard.message.2"
            values={{
              b: (txt) => <b>{txt}</b>,
              emoji: <EmojiRender emoji="😉" />
            }}
          />,
          <FormattedMessage
            id="msp.ai.settings.ai.page.onboard.message.3"
            values={{
              b: (txt) => <b>{txt}</b>,
              emoji: <EmojiRender emoji="😄" />
            }}
          />,
          <FormattedMessage
            id="msp.ai.settings.ai.page.onboard.message.4"
            values={{
              b: (txt) => <b>{txt}</b>,
              emoji: <EmojiRender emoji="😉" />
            }}
          />,
          <FormattedMessage
            id="msp.ai.settings.ai.page.onboard.message.5"
            values={{
              b: (txt) => <b>{txt}</b>,
              emoji: <EmojiRender emoji="😎" />
            }}
          />
        ]
      }
    ]
  },
  REPORTS_CHARTS_HOME: {
    url: [
      {
        url: 'profitablity',
        options: [],
        onboardMessage: [
          <FormattedMessage
            id="msp.ai.efficiency.reports.onboard.message.1"
            values={{
              b: (txt) => <b>{txt}</b>,
              img: <SVGIcon name="AIWand" size="sm" />
            }}
          />,
          <FormattedMessage
            id="msp.ai.efficiency.reports.onboard.message.2"
            values={{
              b: (txt) => <b>{txt}</b>,
              img: <SVGIcon name="AIWand" size="sm" />
            }}
          />,
          <FormattedMessage
            id="msp.ai.efficiency.reports.onboard.message.3"
            values={{
              b: (txt) => <b>{txt}</b>,
              img: <SVGIcon name="AIWand" size="sm" />
            }}
          />,
          <FormattedMessage
            id="msp.ai.efficiency.reports.onboard.message.4"
            values={{
              b: (txt) => <b>{txt}</b>,
              img: <SVGIcon name="AIWand" size="sm" />
            }}
          />
        ]
      }
    ]
  },
  SCRIPT_DETAIL: {
    flag: 'aiScriptGen',
    options: [],
    onboardMessage: [
      <FormattedMessage
        id="msp.ai.script.ai.generation.onboard.message.1"
        values={{
          icon: <SVGIcon name="AIWand" size="sm" />,
          br: () => <br></br>
        }}
      />
    ]
  },
  RMM_HOME: {
    url: [
      {
        url: 'patch',
        options: [],
        onboardMessage: [
          <FormattedMessage id="ai.patch.agent.onboard.message" />
        ]
      }
    ]
  },
  CREATE_SCRIPT: {
    flag: 'aiScriptGen',
    options: [],
    onboardMessage: [
      <FormattedMessage
        id="msp.ai.script.ai.generation.onboard.message.1"
        values={{
          icon: <SVGIcon name="AIWand" size="sm" />,
          br: () => <br></br>
        }}
      />
    ]
  }
};

const checkisBetaFeature = (featureName) => {
  const featureNameList = Object.values(BETA_AI_FEATURES);
  return featureNameList.includes(featureName);
};

const GlobalAIHook = () => {
  const intl = useIntl();
  const tabContext = useContext(TabContext);
  const activeTab = tabContext?.activeTab;
  const aiFeatureHook = AIFeaturesHook();
  const { getIsAIFeatureEnabled } = aiFeatureHook;
  const { getOnboardingConfig } = AIOnboardingHook();

  const getAIProps = ({ name, feature, customProps }) => {
    // From here we'll send Emit the data needed to open AI summary
    // Added texts:
    // copyButtonText -> Copy and paste button text
    // CopySuccessText -> Text on copy success
    // headingText -> Text inside the display container
    // headingIcon -> Icon along with headingText in display container
    // successText -> Text on the top with AI icon once the data is success
    // loading text -> Text while loading
    // hideFeedback -> hide thumbs up and down
    // hideBack -> hides go back,
    const featureName = name || feature?.featureName;

    let data = {};

    switch (featureName) {
      case AI_AGENTS_MAP.TICKET_CONVERSATION_SUMMARIZE:
        data = {
          type: 'SUMMARY',
          hideCopyPaste: true,
          workItem: {
            itemId: activeTab?.data?.ticketId,
            module: 'TICKET'
          },
          summaryCase: 'OVERALL',
          summaryType: 'POINTS',
          variables: {
            input: {
              itemId: activeTab?.data?.ticketId,
              itemType: 'TICKET',
              summaryCase: 'OVERALL',
              summaryType: 'POINTS'
            }
          },
          headingText: getTranslatedText(intl, 'common.ai.ticket.summary'),
          headingIcon: 'AI_TICKET',
          successText: [
            getTranslatedText(intl, 'msp.ai.ticket.summary.success.message.1'),
            getTranslatedText(intl, 'msp.ai.ticket.summary.success.message.2'),
            getTranslatedText(intl, 'msp.ai.ticket.summary.success.message.3'),
            getTranslatedText(intl, 'msp.ai.ticket.summary.success.message.4')
          ],
          loadingText: [
            getTranslatedText(intl, 'msp.ai.ticket.summary.loading.message.1'),
            getTranslatedText(intl, 'msp.ai.ticket.summary.loading.message.2'),
            getTranslatedText(intl, 'msp.ai.ticket.summary.loading.message.3'),
            getTranslatedText(intl, 'msp.ai.ticket.summary.loading.message.4'),
            getTranslatedText(intl, 'msp.ai.ticket.summary.loading.message.5'),
            getTranslatedText(intl, 'msp.ai.ticket.summary.loading.message.6'),
            getTranslatedText(intl, 'msp.ai.ticket.summary.loading.message.7')
          ],
          showRatingComponentOnMount: true,
          mixpanelEventOnClick: {
            event: 'Clicked on AI ticket summary from Monica bot',
            data: {
              ticketId: activeTab?.data?.ticketId
            }
          }
        };
        break;
      case AI_AGENTS_MAP.TICKET_NOTE_SUMMARIZE:
        data = {
          type: 'SUMMARY',
          workItem: {
            itemId: activeTab?.data?.ticketId,
            module: 'TICKET'
          },
          summaryCase: 'NOTE',
          summaryType: 'POINTS',
          variables: {
            input: {
              itemId: activeTab?.data?.ticketId,
              itemType: 'TICKET',
              summaryCase: 'NOTE',
              summaryType: 'POINTS'
            }
          },
          headingText: getTranslatedText(intl, 'common.ai.ticket.summary'),
          headingIcon: 'AI_TICKET',
          successText: [
            getTranslatedText(intl, 'msp.ai.ticket.summary.success.message.1'),
            getTranslatedText(intl, 'msp.ai.ticket.summary.success.message.2'),
            getTranslatedText(intl, 'msp.ai.ticket.summary.success.message.3'),
            getTranslatedText(intl, 'msp.ai.ticket.summary.success.message.4')
          ],
          onCopy: (content, data) => {
            EventEmitter.dispatch('insertEditorContent', content);
          },
          copyButtonText: getTranslatedText(intl, 'common.insert.text'),
          copySuccessText: getTranslatedText(intl, 'common.inserted'),
          showRatingOnCopy: true,
          mixpanelEventOnClick: {
            event: 'Clicked on AI note summary',
            data: {
              ticketId: activeTab?.data?.ticketId
            }
          },
          mixpanelEventOnCopy: {
            event: 'Copy and Pasted - AI ticket note summary',
            data: {
              ticketId: activeTab?.data?.ticketId
            }
          },
          loadingText: [
            getTranslatedText(
              intl,
              'msp.ai.ticket.note.summary.loading.message.1'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.note.summary.loading.message.2'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.note.summary.loading.message.3'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.note.summary.loading.message.4'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.note.summary.loading.message.5'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.note.summary.loading.message.6'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.note.summary.loading.message.7'
            )
          ]
        };
        break;
      case AI_AGENTS_MAP.SIDE_CONVERSATION_COMPOSE:
        data = {
          type: 'SUMMARY',
          workItem: {
            itemId: activeTab?.data?.ticketId,
            module: 'TICKET'
          },
          summaryCase: 'SIDE_CONVERSATION',
          summaryType: 'POINTS',
          variables: {
            input: {
              itemId: activeTab?.data?.ticketId,
              itemType: 'TICKET',
              summaryCase: 'SIDE_CONVERSATION',
              summaryType: 'POINTS'
            }
          },
          onClick: () => EventEmitter.dispatch('openTicket.side.conversation'),
          onCopy: (content, data) => {
            EventEmitter.dispatch('global.ai.sideconversation.onCopy', content);
          },
          headingText: getTranslatedText(intl, 'common.vendor.email'),
          headingIcon: 'AI_MAIL',
          copyButtonText: getTranslatedText(intl, 'common.insert.text'),
          copySuccessText: getTranslatedText(intl, 'common.inserted'),
          showRatingOnCopy: true,
          successText: [
            getTranslatedText(
              intl,
              'msp.ai.vendor.conversation.success.message.1'
            ),
            getTranslatedText(
              intl,
              'msp.ai.vendor.conversation.success.message.2'
            ),
            getTranslatedText(
              intl,
              'msp.ai.vendor.conversation.success.message.3'
            ),
            getTranslatedText(
              intl,
              'msp.ai.vendor.conversation.success.message.4'
            )
          ],
          loadingText: [
            getTranslatedText(
              intl,
              'msp.ai.vendor.conversation.loading.message.1'
            ),
            getTranslatedText(
              intl,
              'msp.ai.vendor.conversation.loading.message.2'
            ),
            getTranslatedText(
              intl,
              'msp.ai.vendor.conversation.loading.message.3'
            ),
            getTranslatedText(
              intl,
              'msp.ai.vendor.conversation.loading.message.4'
            ),
            getTranslatedText(
              intl,
              'msp.ai.vendor.conversation.loading.message.5'
            ),
            getTranslatedText(
              intl,
              'msp.ai.vendor.conversation.loading.message.6'
            ),
            getTranslatedText(
              intl,
              'msp.ai.vendor.conversation.loading.message.7'
            )
          ],
          mixpanelEventOnClick: {
            event: 'Clicked on AI Side conversation compose from Monica bot',
            data: {
              ticketId: activeTab?.data?.ticketId
            }
          },
          mixpanelEventOnCopy: {
            event: 'Copy and Pasted - AI side conversation compose',
            data: {
              ticketId: activeTab?.data?.ticketId
            }
          }
        };
        break;
      case AI_AGENTS_MAP.TICKETS_SUMMARY_BY_CATEGORY:
        data = {
          hideCopyPaste: true,
          Api: GET_CATEGORY_SUMMARY,
          accessorKey: 'getCategorySummary',
          dataComponent: TicketCategorySummary,
          headingText: getTranslatedText(
            intl,
            'ai.summary.ticket.category.heading'
          ),
          headingIcon: 'AI_TICKET_SUMMARY',
          hideFeedback: true,
          hideBack: true,
          successText: [
            getTranslatedText(
              intl,
              'msp.ai.ticket.category.summary.success.message.1'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.category.summary.success.message.2'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.category.summary.success.message.3'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.category.summary.success.message.4'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.category.summary.success.message.5'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.category.summary.success.message.6'
            )
          ],
          loadingText: [
            getTranslatedText(
              intl,
              'msp.ai.ticket.category.summary.loading.message.1'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.category.summary.loading.message.2'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.category.summary.loading.message.3'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.category.summary.loading.message.4'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.category.summary.loading.message.5'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.category.summary.loading.message.6'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.category.summary.loading.message.7'
            )
          ],
          mixpanelEventOnClick: { event: 'Click on one click summary option' },
          showRatingComponentOnMount: true
        };
        break;
      case AI_AGENTS_MAP.SCRIPT_GENERATION:
        data = {
          Api: GET_AI_README,
          accessorKey: 'getAIScriptGenerationReadme',
          headingText: getTranslatedText(intl, 'attribute.readme'),
          options: [],
          headingIcon: 'AIWand',
          hideFeedback: false,
          hideBack: false,
          successText: [
            getTranslatedText(intl, 'msp.ai.script.success.message')
          ],
          loadingText: [
            getTranslatedText(intl, 'msp.ai.script.readme.loading.message.1'),
            getTranslatedText(intl, 'msp.ai.script.readme.loading.message.2'),
            getTranslatedText(intl, 'msp.ai.script.readme.loading.message.3')
          ],
          copyButtonText: getTranslatedText(intl, 'common.insert'),
          copySuccessText: getTranslatedText(intl, 'common.inserted'),
          onCopy: (content, data) => {
            EventEmitter.dispatch('insertScriptReadmeContent', content);
          }
        };
        break;
      case 'WORKLOG_SUMMARIZATION':
        data = {
          hideCopyPaste: true,
          Api: GET_TICKET_WORKLOG_SUMMARY,
          accessorKey: 'getWorklogSummary',
          headingText: getTranslatedText(
            intl,
            'common.ai.worklog.summary.heading'
          ),
          headingIcon: 'AI_WORKLOG',
          hideFeedback: true,
          variables: {
            ticketId: activeTab?.data?.ticketId
          },
          dataComponent: TicketWorklogSummary,
          successText: [
            getTranslatedText(
              intl,
              'msp.ai.ticket.worklog.summary.success.message.1'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.worklog.summary.success.message.2'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.worklog.summary.success.message.3'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.worklog.summary.success.message.4'
            )
          ],
          loadingText: [
            getTranslatedText(
              intl,
              'msp.ai.ticket.worklog.summary.loading.message.1'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.worklog.summary.loading.message.2'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.worklog.summary.loading.message.3'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.worklog.summary.loading.message.4'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.worklog.summary.loading.message.5'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.worklog.summary.loading.message.6'
            ),
            getTranslatedText(
              intl,
              'msp.ai.ticket.worklog.summary.loading.message.7'
            )
          ],
          mixpanelEventOnClick: {
            event: 'Clicked on AI worklog summarise from Monica bot',
            data: {
              ticketId: activeTab?.data?.ticketId
            }
          },
          showRatingComponentOnMount: true
        };
        break;
      case AI_AGENTS_MAP.SIMILAR_TICKETS:
        data = {
          hideCopyPaste: true,
          Api: GET_AI_SIMILAR_TICKETS,
          accessorKey: 'getAISimilarTickets',
          headingText: getTranslatedText(
            intl,
            'common.ai.worklog.summary.heading'
          ),
          headingIcon: 'AI_WORKLOG',
          hideFeedback: true,
          variables: {
            ticketId: activeTab?.data?.ticketId
          },
          dataComponent: AISimilarTickets,
          successText: [
            getTranslatedText(intl, 'msp.ai.similar.tickets.success.message.1'),
            getTranslatedText(intl, 'msp.ai.similar.tickets.success.message.2'),
            getTranslatedText(intl, 'msp.ai.similar.tickets.success.message.3'),
            getTranslatedText(intl, 'msp.ai.similar.tickets.success.message.4')
          ],
          loadingText: [
            getTranslatedText(intl, 'msp.ai.similar.tickets.loading.message.1'),
            getTranslatedText(intl, 'msp.ai.similar.tickets.loading.message.2'),
            getTranslatedText(intl, 'msp.ai.similar.tickets.loading.message.3'),
            getTranslatedText(intl, 'msp.ai.similar.tickets.loading.message.4')
          ],
          mixpanelEventOnClick: {
            event: 'Clicked on Similar ticket from Monica bot',
            data: {
              ticketId: activeTab?.data?.ticketId
            }
          },
          plainBackground: true,
          enableOnboarding: true,
          showRatingComponentOnMount: true
        };
        break;
      case AI_AGENTS_MAP.RECOMMENDED_SOLUTION:
        data = {
          hideCopyPaste: true,
          hideBack: true,
          Api: GET_AI_RECOMMENDED_SOLUTIONS_V2,
          accessorKey: 'getAIRecommendedSolutionsV2',
          headingText: getTranslatedText(
            intl,
            'common.ai.worklog.summary.heading'
          ),
          headingIcon: 'AI_WORKLOG',
          hideFeedback: true,
          variables: {
            ticketId: activeTab?.data?.ticketId
          },
          dataComponent: AIRecommendedSolutions,
          successText: [
            getTranslatedText(
              intl,
              'msp.ai.recommended.solutions.success.message.1'
            ),
            getTranslatedText(
              intl,
              'msp.ai.recommended.solutions.success.message.2'
            ),
            getTranslatedText(
              intl,
              'msp.ai.recommended.solutions.success.message.3'
            ),
            getTranslatedText(
              intl,
              'msp.ai.recommended.solutions.success.message.4'
            )
          ],
          loadingText: [
            getTranslatedText(
              intl,
              'msp.ai.recommended.solutions.loading.message.1'
            ),
            getTranslatedText(
              intl,
              'msp.ai.recommended.solutions.loading.message.2'
            ),
            getTranslatedText(
              intl,
              'msp.ai.recommended.solutions.loading.message.3'
            ),
            getTranslatedText(
              intl,
              'msp.ai.recommended.solutions.loading.message.4'
            )
          ],
          mixpanelEventOnClick: {
            event: 'Clicked on Recommended solutions from Monica bot',
            data: {
              ticketId: activeTab?.data?.ticketId
            }
          },
          plainBackground: true,
          enableOnboarding: true
        };
        break;
      case AI_AGENTS_MAP.KNOWLEDGE_BASE:
        data = {
          hideCopyPaste: true,
          hideBack: true,
          Api: GET_AI_KB_ARTICLE_V2,
          accessorKey: 'getAIKBArticleV2',
          variables: {
            ticketId: activeTab?.data?.ticketId,
            includeSimilarTickets:
              getIsAIFeatureEnabled('SIMILAR_TICKETS') ||
              getIsAIFeatureEnabled('RECOMMENDED_SOLUTION')
                ? true
                : false
          },
          hideFeedback: true,
          dataComponent: AIKnowledgeBase,
          successText: [
            getTranslatedText(intl, 'msp.ai.knowledge.base.success.message.v2')
          ],
          loadingText: [
            getTranslatedText(intl, 'msp.ai.knowledge.base.loading.message')
          ],
          mixpanelEventOnClick: {
            event: 'Clicked on Generate Kb from Monica bot',
            data: {
              ticketId: activeTab?.data?.ticketId
            }
          },
          plainBackground: true
        };
        break;
      case AI_AGENTS_MAP.TICKET_TRIAGE:
        data = {
          hideCopyPaste: true,
          Api: GET_TICKET_TRIAGE,
          client: TicketClient,
          accessorKey: 'getTicket',
          headingText: getTranslatedText(
            intl,
            'common.ai.worklog.summary.heading'
          ),
          headingIcon: 'AI_WORKLOG',
          hideFeedback: true,
          variables: {
            id: activeTab?.data?.ticketId
          },
          dataComponent: AITicketTriage,
          successText: [
            getTranslatedText(intl, 'msp.ai.ticket.triage.success.message.1'),
            getTranslatedText(intl, 'msp.ai.ticket.triage.success.message.2'),
            getTranslatedText(intl, 'msp.ai.ticket.triage.success.message.3'),
            getTranslatedText(intl, 'msp.ai.ticket.triage.success.message.4')
          ],
          loadingText: [
            getTranslatedText(intl, 'msp.ai.ticket.triage.loading.message.1'),
            getTranslatedText(intl, 'msp.ai.ticket.triage.loading.message.2'),
            getTranslatedText(intl, 'msp.ai.ticket.triage.loading.message.3'),
            getTranslatedText(intl, 'msp.ai.ticket.triage.loading.message.4')
          ],
          mixpanelEventOnClick: {
            event: 'Clicked on Ticket triage from ticket',
            data: {
              ticketId: activeTab?.data?.ticketId
            }
          },
          plainBackground: true,
          enableOnboarding: true,
          showAIOptions: true,
          hideBack: true
        };
        break;
      default:
        data = {};
    }

    const extraParams = customProps ? { ...customProps } : {};

    const isBetaFeature = checkisBetaFeature(featureName);

    // Add onboarding support
    const onboardingProps = {
      onboardingConfig: getOnboardingConfig(featureName)
    };

    return {
      ...data,
      beta: isBetaFeature,
      ...extraParams,
      ...onboardingProps,
      featureName: featureName
    };
  };

  return { AI_CONFIG, getAIProps };
};

export { AI_CONFIG, GlobalAIHook };
